<template>
  <section class="ugc-bottom-bar">
    <div class="row ugc-bottom-bar-buttons-wrapper">
      <div class="small-6 large-6 columns ugc-bottom-bar-buttons-wrapper-go-back">
        <button
          :disabled="!enableGoBackButton"
          type="button"
          class="button secondary ugc-bottom-bar-cta"
          @click="$emit('go-back')"
        >{{ translations.ugcModalBack }}</button>
      </div>
      <div class="small-6 large-6 columns ugc-bottom-bar-buttons-wrapper-advance">
        <button
          @click="$emit('next')"
          class="button primary ugc-bottom-bar-cta hide"
          type="button"
        >{{ translations.ugcTopBarNext }}</button>
        <button
          :disabled="!enableGoBackButton"
          @click="$emit('finish')"
          :class="['button primary ugc-bottom-bar-cta', { hide: !showFinishButton }]"
          type="button"
        >{{ translations.ugcTopBarFinish }}</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "UgcBottomBar",
  data() {
    return {
      enableGoBackButton: true,
      enableFinishButton: false,
      showFinishButton: true,
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    }
  },
  methods: {
    setEnableGoBackButton(enable = false) {
      this.enableGoBackButton = enable;
    },

    setEnableFinishButton(enable = true) {
      this.enableFinishButton = enable;
    },

    setShowFinishButton(show = true) {
      this.showFinishButton = show;
    },

    onDisableGoBackButton(disable = true) {
      this.setEnableGoBackButton(!disable);
    },

    onDisableFinishButton(disable = false) {
      this.setEnableFinishButton(!disable);
    },
  },

  created() {
    this.$eventBus.$on("show-finish-button", this.setShowFinishButton);
    this.$eventBus.$on("disable-next-back-buttons", this.onDisableGoBackButton);
    this.$eventBus.$on("disable-finish-button", this.onDisableFinishButton);
  },

  beforeDestroy() {
    this.$eventBus.$off("show-finish-button", this.setShowFinishButton);
    this.$eventBus.$off("disable-next-back-buttons", this.onDisableGoBackButton);
    this.$eventBus.$off("disable-finish-button", this.onDisableFinishButton);
  },
};
</script>
